import React, { useState } from "react";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import MuiDrawer from "@mui/material/Drawer";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { Stack } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { map } from "lodash";
const drawerWidth = 300;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(12)} + 1px)`,
  },
});

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));

export const MenuItem = (props) => {
  const {
    text,
    open,
    Icon,
    link,
    onClick,
    linkProps,
    isShow = true,
    ...restProps
  } = props;
  const navigate = useNavigate();
  const location = useLocation();
  const isActive = location.pathname.startsWith(link);
  if (!isShow) return;
  return (
    <Stack
      direction={"row"}
      alignItems={"center"}
      gap={1.5}
      paddingInline={2.5}
      paddingBlock={1.5}
      {...restProps}
      sx={{
        my: 1,
        borderRadius: "8px",
        color: isActive ? "#FFFFFF" : "#839BB0",
        transition: "all 0.15s ease-in-out",
        backgroundColor: isActive ? "#0A72C3" : "#F2F2F3",
        "&:hover": {
          borderRadius: "8px",
          color: "#FFF",
          backgroundColor: "#0A72C3",
        },
        cursor: "pointer",
        ...(!open && {
          width: "3.5rem",
          height: "3.35rem",
          justifyContent: "center",
        }),
        ...restProps?.sx,
        minWidth: 0,
      }}
      onClick={() => {
        onClick?.();
        if (link) {
          navigate(link);
        }
      }}
    >
      <Box
        sx={{
          width: "1.65rem",
          height: "1.65rem",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
          ml: open ? 0 : ".75rem",
        }}
      >
        <Icon style={{ width: "100%", height: "100%" }} />
      </Box>

      <Typography
        fontWeight={600}
        fontSize="1rem"
        sx={{
          whiteSpace: "nowrap",
          overflow: "hidden",
          transition: "max-width 0.3s ease, opacity 0.3s ease",
          maxWidth: open ? "200px" : "0px",
          opacity: open ? 1 : 0,
          display: "inline-block",
        }}
      >
        {text}
      </Typography>
    </Stack>
  );
};
export const DesktopSideBar = (props) => {
  const { content } = props;

  const [open, setOpen] = useState(true);
  const onToggleDrawer = () => {
    setOpen(!open);
  };
  return (
    <Drawer
      variant="permanent"
      open={open}
      PaperProps={{
        sx: {
          backgroundColor: "#F2F2F3",
          borderRight: "1px solid #DBE4EC",
          paddingInline: open ? 3 : 0,
          paddingTop: 4,
        },
      }}
    >
      <Stack
        justifyContent={open ? "space-between" : "center"}
        alignItems={"center"}
        flexDirection={"row"}
        paddingBottom={1}
      >
        {open && <img src="/images/sidebar-logo-v2.png" alt="logo" />}
        <IconButton onClick={onToggleDrawer}>
          {!open ? (
            <ChevronRightIcon style={{ color: "#0A72C3" }} />
          ) : (
            <ChevronLeftIcon style={{ color: "#0A72C3" }} />
          )}
        </IconButton>
      </Stack>
      <Stack
        height={"100%"}
        justifyContent={"space-between"}
        direction={"column"}
        width={"100%"}
      >
        <Stack
          justifyContent={"center"}
          alignItems={!open ? "center" : "stretch"}
          width={"100%"}
        >
          {map(content.top, (content) => {
            return (
              <MenuItem
                key={content.id}
                text={content.title}
                Icon={content.Icon}
                link={content.link}
                open={open}
                onClick={content.onClick}
                isShow={content.isShow}
                {...content?.desktopProps}
              />
            );
          })}
        </Stack>
        <Stack
          justifyContent={"center"}
          alignItems={!open ? "center" : "stretch"}
          width={"100%"}
          pb={3}
        >
          {map(content.bottom, (content) => {
            return (
              <MenuItem
                key={content.id}
                text={content.title}
                Icon={content.Icon}
                open={open}
                onClick={content.onClick}
                isShow={content.isShow}
                {...content?.desktopProps}
              />
            );
          })}
        </Stack>
      </Stack>
    </Drawer>
  );
};
